import(/* webpackMode: "eager" */ "/app/apps/lab-app/app/providers.tsx");
import(/* webpackMode: "eager" */ "/app/node_modules/sonner/dist/index.mjs")